import { Link } from 'react-router-dom';
import {
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../helpers/helpers';

import { getUserFromLS } from '../../../helpers/localstorage-helper';
import PackageOrdersActions from './actions';

export const columns = [
  {
    id: 1,
    Header: 'Withdrawal ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },
  {
    id: 2,
    Header: 'External Payout ID',
    accessor: 'externalPayoutId',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },

  {
    id: 3,
    Header: 'User ID',
    accessor: 'user',
    Cell: (cell: any) => {
      if (cell?.value?.isBlacklisted) {
        return (
          <Link className='text-secondary' to={`/users/${cell?.value?.id}`}>
            <div style={{ color: 'red' }}>{`! ${cell?.value?.id}`}</div>
          </Link>
        );
      } else {
        return (
          <Link className='text-secondary' to={`/users/${cell?.value?.id}`}>
            {cell?.value?.id}
          </Link>
        );
      }
    }
  },
  {
    id: 4,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <>
          {cell.value?.name} {cell.value?.surname}
        </>
      );
    }
  },

  {
    id: 5,
    Header: 'Amount',
    accessor: 'paidAmount',
    Cell: (cell: any) => {
      return cell?.value ? usdFormatter.format(cell?.value) : '---';
    }
  },

  {
    id: 6,
    Header: 'Fee',
    accessor: 'feeAmount',
    Cell: (cell: any) => {
      return usdFormatter.format(cell.row.original.feeAmount);
    }
  },

  {
    id: 7,
    Header: 'IBAN',
    accessor: 'iban',
    Cell: (cell: any) => {
      return <> {cell.value}</>;
    }
  },

  {
    id: 8,
    Header: 'Country Code',
    accessor: 'countryCode',
    Cell: (cell: any) => {
      return <> {cell.value}</>;
    }
  },

  {
    id: 9,
    Header: 'City',
    accessor: 'city',
    Cell: (cell: any) => {
      return <> {cell.value}</>;
    }
  },

  {
    id: 10,
    Header: 'Postal Code',
    accessor: 'postalCode',
    Cell: (cell: any) => {
      return <> {cell.value}</>;
    }
  },

  {
    id: 11,
    Header: 'Address',
    accessor: 'street',
    Cell: (cell: any) => {
      return <> {cell.value}</>;
    }
  },
  {
    id: 12,
    Header: 'Date Created',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell.value)},
        <small className='text-muted'> {handleValidTime(cell.value)}</small>
      </>
    )
  },

  {
    id: 13,
    Header: 'Date Paid',
    accessor: 'datePaid',
    Cell: (cell: any) => (
      <>
        {cell.value ? (
          <>
            {' '}
            {handleValidDate(cell.value)},
            <small className='text-muted'> {handleValidTime(cell.value)}</small>
          </>
        ) : (
          '---'
        )}
      </>
    )
  },

  {
    id: 14,
    Header: 'Status',
    accessor: 'status',
    Cell: (cell: any) => {
      switch (cell.value) {
        case 1:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              Pending
            </span>
          );

        case 2:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              Paid
            </span>
          );

        case 3:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              Completed
            </span>
          );

        case 4:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              Canceled
            </span>
          );

        case 5:
          return (
            <span className='badge text-uppercase badge-soft-info'>
              Automatic payout in progress
            </span>
          );

        case 6:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              Automatic payout paid
            </span>
          );

        default:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              Not paid
            </span>
          );
      }
    }
  },

  {
    id: 15,
    Header: 'Actions',
    accessor: 'id',
    Cell: (cell: any) => {
      return <PackageOrdersActions {...cell} />;
    }
  }
  // {
  //   id: 10,
  //   Header: () => {
  //     const { showActionButtons } = useAppSelector(
  //       (state) => state.withdrawals
  //     );
  //     return showActionButtons ? 'Multiple payouts' : '';
  //   },

  //   accessor: 'checked',

  //   Cell: (cell: any) => {
  //     const { showActionButtons } = useAppSelector(
  //       (state) => state.withdrawals
  //     );
  //     return showActionButtons ? <AutomaticPayout {...cell} /> : <div></div>;
  //   }
  // }
];
